import {Panes, TextField} from '@management-ui/core';
import React from 'react';
import YesNoField from '../../../../components/YesNoField';

const Fields = ({person = {}, prefix = ''}) => {
  return (
    <Panes
      entity={person}
      prefix={prefix}
      panes={[
        {
          title: 'Person',
          fields: [
            <TextField
              name="first_name"
              prefix={prefix}
              label="First Name"
              rules={{required: 'Please enter a first name'}}
            />,
            <TextField
              name="last_name"
              prefix={prefix}
              label="Last Name"
            />,
            <TextField
              name="position"
              prefix={prefix}
              label="Position / Job Title"
            />,
            <TextField
              name="phone"
              prefix={prefix}
              label="Telephone Number"
            />,
            <TextField
              name="email"
              prefix={prefix}
              label="Email Address"
            />,
            <YesNoField
              name="is_key"
              prefix={prefix}
              label="Is this the key contact?"
            />,
            <YesNoField
              name="is_accounts"
              prefix={prefix}
              label="Is this the accounts contact?"
            />,
          ]
        }
      ]}
      title=""/>
  );
};

export default Fields;
